/* eslint-disable max-len */
import React from 'react';

interface IProblemProps {
    color: string;
}

const Problem: React.FC<IProblemProps> = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0C10.1217 0 12.1569 0.842489 13.6572 2.34277C15.1574 3.84306 16 5.87827 16 8C16 10.1217 15.1574 12.1569 13.6572 13.6572C12.1569 15.1574 10.1217 16 8 16C5.87827 16 3.84306 15.1574 2.34277 13.6572C0.842489 12.1569 0 10.1217 0 8C0 5.87827 0.842473 3.84306 2.34277 2.34277C3.84306 0.842473 5.87827 0 8 0ZM8 10.5C7.73478 10.5 7.4805 10.6054 7.29297 10.793C7.10543 10.9805 7 11.2348 7 11.5C7 11.7652 7.10543 12.0195 7.29297 12.207C7.4805 12.3946 7.73478 12.5 8 12.5C8.26522 12.5 8.5195 12.3946 8.70703 12.207C8.89457 12.0195 9 11.7652 9 11.5C9 11.2348 8.89457 10.9805 8.70703 10.793C8.5195 10.6054 8.26522 10.5 8 10.5ZM8 3.16602C7.73478 3.16602 7.4805 3.27145 7.29297 3.45898C7.10543 3.64652 7 3.9008 7 4.16602V8.49902C7 8.76407 7.14565 9.01855 7.33301 9.20605C7.52054 9.39359 7.73478 9.49902 8 9.49902C8.26522 9.49902 8.5195 9.39359 8.70703 9.20605C8.89447 9.01853 9 8.76416 9 8.49902V4.16602C9 3.9008 8.89457 3.64652 8.70703 3.45898C8.5195 3.27145 8.26522 3.16602 8 3.16602Z"
                fill={color}
            />
        </svg>

    );
};

export default Problem;